// extracted by mini-css-extract-plugin
export var authorBioEditorialAbout = "F_bX";
export var authorBioEditorialContainer = "F_bW";
export var authorBioEditorialXp = "F_bY";
export var authorBioPageContainer = "F_bV";
export var relatedArticles = "F_x";